import localStorageHelper from '@/helpers/localStorageHelper';
import {
  AUTH_TOKEN_KEY, 
  JIANWEI_AUTH_TOKEN_KEY, 
  ROLE, 
  WECHAT_AUTH_TOKEN_KEY, 
  WECHAT_OPENID_KEY, 
  SEARCH_CONDITION,
  FROM_ROUTER,
  PDF_DETAIL_DATA
} from '@/helpers/constants';

export default class AuthService {
  static isLoggedIn() { // may not reliable if use disabled localstorage (eg. Private mode)
    return !!AuthService.getAuthToken() || !!AuthService.getJianWeiAuthToken() || !!getWechatAuthToken();
  }

  static whoIsLoggedIn() {
    let result = '';
    if (AuthService.getAuthToken()) {
      result = 'yanbaocool';
    } else if (AuthService.getJianWeiAuthToken()) {
      result = 'jianwei';
    } else if (AuthService.getWechatAuthToken()) {
      result = 'yanbaocool-wechat';
    }
    return result;
  }

  static getAuthToken() {
    return localStorageHelper.getItem(AUTH_TOKEN_KEY);
  }

  static getJianWeiAuthToken() {
    return localStorageHelper.getItem(JIANWEI_AUTH_TOKEN_KEY);
  }

  static getWechatAuthToken() {
    return localStorageHelper.getItem(WECHAT_AUTH_TOKEN_KEY);
  }

  static getWechatOpenid() {
    return localStorageHelper.getItem(WECHAT_OPENID_KEY);
  }

  static updateJianWeiAuthToken(newToken) {
    return localStorageHelper.setItem(JIANWEI_AUTH_TOKEN_KEY, newToken);
  }

  static getLoggedUserName() {
    return localStorageHelper.getItem(USER_NAME);
  }

  // static setRole(role) {
  //   return localStorageHelper.setItem(ROLE, role);
  // }

  static getRole() {
    return localStorageHelper.getItem(ROLE);
  }

  static getSearchCondition() {
    return localStorageHelper.getItem(SEARCH_CONDITION);
  }

  static getFromRouter() {
    return localStorageHelper.getItem(FROM_ROUTER);
  }

  static getPdfDetailData() {
    return localStorageHelper.getItem(PDF_DETAIL_DATA);
  }

  static logout() {
    localStorageHelper.removeItem(AUTH_TOKEN_KEY);
    localStorageHelper.removeItem(JIANWEI_AUTH_TOKEN_KEY);
    localStorageHelper.removeItem(ROLE);
    localStorageHelper.removeItem(WECHAT_AUTH_TOKEN_KEY);
    localStorageHelper.removeItem(WECHAT_OPENID_KEY);
  }
}
